import domContentLoaded from "dom-content-loaded";
import { throttle } from "throttle-debounce";
import $ from "jquery";
import "slick-carousel";

domContentLoaded(() => {
  /* メインビジュアル */
  $(".js-home-slider").slick({
    autoplay: true,
    centerMode: true,
    centerPadding: "17%",
    arrows: false,
    dots: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 1281, // 399px以下のサイズに適用
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  /* メインビジュアル */
  const $window = $(window);
  const $homeVisual = $(".js-home-visual");
  const $homeVisualWrapper = $(".js-home-visual-wrapper");

  let homeVisualHeight = Math.floor($homeVisual.innerHeight());
  $homeVisualWrapper.css({
    "padding-top": `${homeVisualHeight}px`,
  });

  $window.on({
    resize: () => {
      homeVisualHeight = Math.floor($homeVisual.innerHeight());
      $homeVisualWrapper.css({
        "padding-top": `${homeVisualHeight}px`,
      });
    },
    scroll: throttle(250, () => {
      if ($window.scrollTop() > 100) {
        $homeVisual.addClass("is-scroll");
      } else {
        $homeVisual.removeClass("is-scroll");
      }
    }),
    load: () => {
      $homeVisual.addClass("is-speech-active");
      setTimeout(() => {
        $homeVisual.removeClass("is-speech-active");
      }, 2000);
      setInterval(() => {
        $homeVisual.addClass("is-speech-active");
        setTimeout(() => {
          $homeVisual.removeClass("is-speech-active");
        }, 2000);
      }, 8000);
    },
  });
});
